<template>
  <div class="info">
    <section class="main_section">
      <div id="info_container" class="ft-content">
        <div class="ftnav-col">
          <h2>COMPANY</h2>
          <ul>
            <li>
              <router-link :to="{name:'AboutUs'}">
                About Us
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ContactUs' }">
                Contact Us
               <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
          </ul>
        </div>
        <div class="ftnav-col">
          <h2>Policies</h2>
          <ul>
            <li>
              <router-link :to="{ name: 'DeliveryPolicy' }">
                Delivery Policy
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'DisclaimerPolicy'}">
                Disclaimer Policy
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'PrivacyPolicy'}">
                Privacy Policy
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'ReturnRefundPolicy'}">
                Return & Refund Policy
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
            <li>
              <router-link :to="{name: 'TermsConditions'}">
                Terms & Conditions
                <img src="../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Info",
  data() {
    return {
      aboutus: false,
      contactus: false,
      Delivery_Policy: false,
      Disclaimer_Policy: false,
      Privacy_Policy: false,
      Return_Refund_Policy: false,
      Terms_Conditions: false,
      msg: "Welcome to Your Vue.js PWA"
    };
  },
  mounted(){
  }
};
</script>
